import { render, staticRenderFns } from "./MajorSummary.vue?vue&type=template&id=61062772"
import script from "./MajorSummary.vue?vue&type=script&lang=js"
export * from "./MajorSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports